import { Component, EventEmitter  } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from 'app/services/user-management.service';
import { Location } from '@angular/common';
import { FrontEndService } from "../../services/front-end.service";
import { LogService } from 'app/services/log.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
    sendState = "forgotPassword";
    username_error = false;
    errorMessage = '';
    username = '';
    fullScreenLoader = false;
    username_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private stateService: StateService,
        private translate: TranslateService,
        public front_end_service: FrontEndService,
        private logService: LogService,
        private _location: Location
    ) { }

    onSubmit(user) {
        const regEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        if ((user.username.trim() === '') || user.username === undefined) {
            this.username = '';
            this.username_focus.emit(true);
            this.username_error = true;
            this.errorMessage = 'enter_an_email_id'
        } else if (!regEx.test(user.username)) {
            this.username_focus.emit(true);
            this.username_error = true;
            this.errorMessage = 'enter_a_valid_email_id'
        } else {
            this.username_error = false;
            this.user_management_service.forgotPassword(user, (resp) => {
                this.front_end_service.addToast("Success", resp.message, "success");

                if(resp.status) {
                    this.stateService.go('login');
                }
            });
        }
    }
}
